export class ApiConfig {
  rootUrl: string;
  clientId: string;
  clientSecret: string;
  baseSite: string;
}
